import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as config from "../constants/config";
import * as handlers from "../constants/handlers";
import * as getActions from "./getActions";

export const initFiltering = (tabId) => ({
    type: actionTypes.FILTERING_INIT,
    payload: {
        tabId: tabId
    }
});

export const changeFilterParams = (tabId, paramType, paramValue) => ({
    type: actionTypes.FILTERING_SAVE_PARAMS,
    payload: {
        tabId: tabId,
        paramType: paramType,
        paramValue: paramValue
    }
});

export const changeCustomFilterParams = (tabId, paramType, paramValue) => ({
    type: actionTypes.FILTERING_SAVE_CUSTOM_PARAMS,
    payload: {
        tabId: tabId,
        paramType: paramType,
        paramValue: paramValue
    }
});

export const filterDefaultProductList = (tabId, productName, fts) => {
    return getActions.getProductsByParams(
        tabId,
        null,
        null,
        null,
        productName,
        false,
        fts,
        true,
        true,
        handlers.FILTERING_GET_DEFAULT_PRODUCT_LIST
    );
};

export const filterDefaultFandeckList = (tabId, fandeckName, fts) => {
    return getActions.getFandecksByParams(
        tabId,
        null,
        null,
        null,
        fandeckName,
        false,
        fts,
        false,
        true,
        handlers.FILTERING_GET_DEFAULT_FANDECK_LIST,
        fandeckName.length >= 3 ? config.MAX_FILTER_ITEMS_LIMIT : config.MAX_FANDECK_LIMIT,
        0,
        false,
        getActions.getFandecksByParams(
            tabId,
            null,
            null,
            null,
            fandeckName,
            true,
            fts,
            false,
            true,
            handlers.FILTERING_GET_LOCAL_FANDECK_LIST,
            fandeckName.length >= 3 ? config.MAX_FILTER_ITEMS_LIMIT : config.MAX_FANDECK_LIMIT
        )
    );
};

export const filterDefaultFormulaList = (tabId, colorName, fts) => {
    return getActions.getColorsByParams(
        tabId,
        null,
        null,
        null,
        colorName,
        null,
        false,
        fts,
        false,
        true,
        handlers.FILTERING_GET_DEFAULT_FORMULA_LIST,
        colorName.length >= 3 ? config.MAX_FILTER_ITEMS_LIMIT : config.MAX_FORMULA_LIMIT,
        0,
        null,
        true,
        false,
        getActions.getColorsByParams(
            tabId,
            null,
            null,
            null,
            colorName,
            null,
            true,
            fts,
            false,
            true,
            handlers.FILTERING_GET_LOCAL_FORMULA_LIST,
            colorName.length >= 3 ? config.MAX_FILTER_ITEMS_LIMIT : config.MAX_FORMULA_LIMIT
        )
    );
};

export const filterDefaultFormulaCodeList = (tabId, colorCode, fts) => {
    return getActions.getColorsByParams(
        tabId,
        null,
        null,
        null,
        null,
        colorCode,
        false,
        fts,
        false,
        true,
        handlers.FILTERING_GET_DEFAULT_FORMULA_CODE_LIST,
        colorCode.length >= 3 ? config.MAX_FILTER_ITEMS_LIMIT : config.MAX_FORMULA_LIMIT,
        0,
        null,
        true,
        false,
        getActions.getColorsByParams(
            tabId,
            null,
            null,
            null,
            null,
            colorCode,
            true,
            fts,
            false,
            true,
            handlers.FILTERING_GET_LOCAL_FORMULA_CODE_LIST,
            colorCode.length >= 3 ? config.MAX_FILTER_ITEMS_LIMIT : config.MAX_FORMULA_LIMIT
        )
    );
};

export const filterDefaultCustomerList = (tabId, customerName) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
        params: {
            search: customerName,
            rowCount: config.MAX_CUSTOMER_LIMIT,
            offset: 0
        }
    },
    method: handlers.FILTERING_GET_DEFAULT_CUSTOMER_LIST,
    tabId: tabId
});
